module.exports = __webpack_public_path__ + "img/logo.75f6d28a.png";